import type {
  InternalNetworkAccessedResourceKind,
  InternalNetworkAdEntityKind,
  InternalNetworkAttackPathEventKind,
  InternalNetworkCredentialPrivilegeTier,
  InternalNetworkCredentialProvenance,
} from '@terra/shared-contracts-internal-network';
import type { InfraImpact } from '@terra/shared-schemas-orchestrator';

export type AttackPathEventNodeRole =
  | 'EVENT'
  | 'OWNED_SEED'
  | 'CROWN_JEWEL_SEED'
  | 'CROWN_JEWEL_CLUSTER'
  | 'UNKNOWN_GAP'
  | 'CAMPAIGN_FRAME'
  | 'ENTITY'
  | 'SIGNAL_EXECUTION';

export const isAttackPathOverlayRole = (
  role: AttackPathEventNodeRole,
): boolean => role === 'CAMPAIGN_FRAME' || role === 'SIGNAL_EXECUTION';

export type AttackPathCampaignStatus =
  | 'PLANNED'
  | 'RUNNING'
  | 'PAUSED'
  | 'COMPLETED'
  | 'ABORTED'
  | 'FAILED';

export type AttackPathEventEdgeVariant = 'proven' | 'hypothesized';

export type AttackPathChainStatus = 'COMPLETED' | 'BLOCKED' | 'IN_PROGRESS';

export type AttackPathEventNodeData = {
  role: AttackPathEventNodeRole;
  campaignId: string | null;
  campaignStatus: AttackPathCampaignStatus | null;
  isCampaignRunning: boolean;
  chainProgress: number;
  kind: InternalNetworkAttackPathEventKind;
  typeLabel: string;
  title: string;
  subtitle: string | null;
  caption: string | null;
  weaknessId: string | null;
  mitreTechniqueId: string | null;
  provenance: InternalNetworkCredentialProvenance | null;
  privilegeTier: InternalNetworkCredentialPrivilegeTier | null;
  resourceKind: InternalNetworkAccessedResourceKind | null;
  severity: string | null;
  status: 'SUCCEEDED' | 'FAILED' | 'IN_PROGRESS';
  isProven: boolean;
  exploitsWeakness: boolean;
  isCrownJewel: boolean;
  isDomainController: boolean;
  impacts: InfraImpact[];
  elapsedSeconds: number;
  occurredAt: string;
  hopIndex: number | null;
  retryCount: number;
  findingId: string | null;
  hostname: string | null;
  entityKind: InternalNetworkAdEntityKind | null;
  entityId: string | null;
  objective: string | null;
  signalId: string | null;
  primaryExecutionId?: string | null;
  durationSeconds: number | null;
  chainStatus: AttackPathChainStatus;
  column: number;
  lane: number;
  dimmed?: boolean;
  hidden?: boolean;
  highlighted?: boolean;
  climaxActive?: boolean;
  entranceActive?: boolean;
  spotlightActive?: boolean;
  pathInkActive?: boolean;
  bootActive?: boolean;
  destinationPull?: 'idle' | 'near' | 'locked';
};

export type AttackPathEventEdgeData = {
  label: string | null;
  variant: AttackPathEventEdgeVariant;
  campaignId: string | null;
  status?: 'SUCCEEDED' | 'FAILED' | 'IN_PROGRESS';
  impactPath?: boolean;
  isCampaignRunning?: boolean;
  dimmed?: boolean;
  hidden?: boolean;
  highlighted?: boolean;
  energyActive?: boolean;
  drawActive?: boolean;
  pathInkActive?: boolean;
  spotlightActive?: boolean;
};
